// Route utilities
/**
 * Input example: "product-page-4/testing-123/PageClientComponent.tsx"
 * Output should be: "product-page-4/testing-123"
 */
export function getRouteFromFilePath(filePath: string) {
  // Drop the last segment (filename), join the remainder as the route path
  const routePath = filePath.split("/").slice(0, -1).join("/") || filePath;
  return routePath;
}

export function normalizeRoute(route: string): string {
  return route.replace(/^\/+/, "").replace(/\/+$/, "");
}

export function detectBuildError(message: string): boolean {
  const errorPatterns = [
    // Next.js compilation errors
    /failed to compile/i,
    /compilation error/i,
    /module not found/i,
    /cannot resolve module/i,
    /syntaxerror/i,
    /typeerror.*at compile time/i,

    // Module parsing errors
    /module parse failed/i,
    /identifier .* has already been declared/i,
    /duplicate identifier/i,
    /redeclaration of/i,

    // TypeScript errors
    /type error/i,
    /TS\d{4}:/,

    // React/JSX errors
    /jsx element .* has no corresponding closing tag/i,
    /expected corresponding jsx closing tag/i,

    // Import/Export errors
    /module '".*"' has no exported member/i,
    /cannot find module/i,
    /attempted import error/i,

    // Build process failures
    /npm err!/i,
    /build failed/i,
    /error occurred prerendering page/i,

    // Next.js specific errors
    /error: element type is invalid/i,
    /unhandled runtime error/i,
  ];

  return errorPatterns.some((pattern) => pattern.test(message));
}

export function detectFileStatusError(message: string): boolean {
  // HTTP error status codes that indicate file/server errors
  const errorStatusCodes = ["404", "500", "502", "503", "504"];

  const httpRequestPattern = /(get)\s+\/\S+\s+(\d{3})\s+in\s+\d+ms/i;
  const match = message.match(httpRequestPattern);

  if (match) {
    const statusCode = match[2];
    return errorStatusCodes.includes(statusCode ?? "");
  }

  return false;
}

export function detect200StatusCode(message: string): boolean {
  const httpRequestPattern = /(get)\s+\/\S+\s+(\d{3})\s+in\s+\d+ms/i;
  const match = message.match(httpRequestPattern);

  if (match) {
    const statusCode = match[2];
    return statusCode === "200";
  }

  return false;
}
